/* eslint-disable no-new-object */
import React, { Component } from "react";
import Landing from "./LandingContainer";
import Form, { formTypes } from "../../Forms/Containers/FormCreator";
// import Button from "@material-ui/core/Button";
import { LANDING_MENU_BAR } from "../../constants/strings/StringsDashboard";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as modalActs from "../../Actions/Modal";
import * as sessionActs from "../../Actions/Session";
import * as systemActs from "../../Actions/System";
import ImgShow from '../../images/100x300.png'

import { sendFile } from '../../Services/service'

import Warning from "@material-ui/icons/Warning";

import "./../changePasswordContainer.css";

class ChangePasswordContainer extends Component {
  state = {
    form: {}
  };
  handlerChange = (variable, value) => {
    this.setState({
      form: {
        ...this.state.form,
        [variable]: value
      }
    });
  };


  modal = (text) => {
    return (
      <>
        <div>
          <div className="modal-icon">
            <div className="center">
              <Warning />
            </div>
            ADVERTENCIA
          </div>
          <div className="modal-message">{text}</div>
          <div className="container-content">
            <Form
              onChange={this.handlerChange}
              objectCreator={[
                {
                  type: formTypes.div,
                  classContainer: "line line-40"
                },
                {
                  type: formTypes.submit,
                  classContainer: "button-primary line line-20 text-center",
                  label: "Aceprtar",
                  placeholder: "-"
                },
                {
                  type: formTypes.div,
                  classContainer: "line line-40"
                }
              ]}
              onSubmit={this.closeModal}
            />
          </div>
        </div>
      </>
    );
  };

  closeModal = (status) => {
    this.props.modalActions.closeModal()
  }

  onUploadAttached = (files) => {
    const img = document.getElementById('img')
    const reader = new FileReader()
    reader.onloadend = function () {
      img.src = reader.result
    }
    reader.readAsDataURL(files[0])
  }



  handlerSubmit = async () => {
    const file = document.getElementById('file').files[0]
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      sendFile(
        '/api/v1/misc/setLogo',
        formData,
        {
          end: (r) => {
            // console.log(this)
            this.props.systemActions.setUrlLogo(r.logo)
            // console.log(r)
          }
        }
      )
    }
    
  };

  render() {
    return (
      <Landing history={this.props.history} hasFooter={true}>
        <>
          <div>
            <h1 className="page-title">{LANDING_MENU_BAR.CHANGE_LOGOS}</h1>
          </div>
          <div className="background-body">
            <div className="content-line">
              <div className="flex-center">
                <div className="button-primary line line-20 text-center">
                  <div className="div-input-button">
                    <input type="button" value="Agregar Imagen" onClick={() => document.getElementById('file').click()} />
                    <input type='file' id="file" onChange={(e) => this.onUploadAttached(e.target.files)} style={{ display: 'none' }} />
                  </div>
                </div>
              </div>


              <div className="flex-center">
                <div className="flex-center" style={{ border: '2px dashed black', height: '100px', width: '300px', backgroundColor: 'aliceblue' }}>
                  <img id='img' height={100} width={300} alt="imagen nueva" src={ImgShow} />
                </div>
              </div>


              <div className="flex-center">
                <div className="button-primary line line-20 text-center">
                  <div className="div-input-button" style={{ backgroundColor: 'var(--primary-color)' }} >
                    <input type="button" value="Guardar" onClick={this.handlerSubmit} style={{ backgroundColor: 'var(--primary-color)', color: 'white' }} />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </>
      </Landing>
    );
  }
}

// export default ChangePasswordContainer;

function mapStateToProps(state, props) {
  return {
    session: state.session
    // open: state.modal.open,
    // children: state.modal.children
  };
}


function mapDispatchToProps(dispatch) {
  return {
    modalActions: bindActionCreators(modalActs, dispatch),
    sessionActions: bindActionCreators(sessionActs, dispatch),
    systemActions: bindActionCreators(systemActs, dispatch)
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordContainer);
